const postBookingOrder = (fetcher) => ({
  createPostBookingOrder: (order_id, order) =>
    fetcher(`/me/orders/${order_id}/ancillaries/baggages/orders`, {
      method: 'POST',
      body: { ...order },
    }),
})

export default postBookingOrder
